import React from 'react';
import { addFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';
import SearchInput from '../../common/components/_SearchBox';
import DropdownItem from '../../common/components/_DropdownItem';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';
import DropdownTreeSelect from 'react-dropdown-tree-select';

function GenericPressReleasesFilter({ search, filters, settings }) {

    let data = d => {
        return d.children.map(c => ({ checked: (search.categories && search.categories.toString().split(',').includes(c.key) ? true : false ), label: c.name, value: c.key, children: c.children.map(ch => ({ label:ch.name, value: ch.key})) }));
    };

    const onChange = (currentNode, selectedNodes) => {
        addFilter(search, 'categories', currentNode.value, currentNode.checked);
    };

	return (
        <div className="filter-bar">
            <div className="filter__text">
                Filter by
            </div>
            <SearchInput search={search} settings={settings}/>
            {/* {filters && filters.taxonomyFilters && <DropdownItem search={search} title='Industries' options={filters.taxonomyFilters.industries} name='industries' istaxonomy={true} />}
            {filters && filters.taxonomyFilters && <DropdownTreeSelect name="categories" data={data(filters.taxonomyFilters.categories)} onChange={onChange} keepTreeOnSearch='true' clearSearchOnChange='true' placeholderText='Topics...' />} */}
            <DateFilterDropdown search={search} isYear={true} settings={settings} />
        </div>
	);
}

GenericPressReleasesFilter.propTypes = {
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default GenericPressReleasesFilter;
